import { navigate } from 'gatsby'
import { useAuth } from 'contexts/AuthContext'
import { useState, useEffect } from 'react'

const useNeedsMembership = (needsMembership = true) => {
    const [showLoaderPage, setShowLoaderPage] = useState(false);
    const [showAccountError, setShowAccountError] = useState(false);
    const { currentUser, loading, authError } = useAuth()

    useEffect(() => {
        if (needsMembership && !loading && currentUser === null) {
            navigate('/sign-in')
        }
    }, [currentUser, loading, needsMembership])

    useEffect(() => {
        // Authenticated, but loginCheck couldn't load the account (e.g. no
        // matching record in our database). Surfaced separately so pages can
        // tell the member to call in instead of showing the generic loader.
        const accountError = Boolean(needsMembership && !loading && authError)

        const loaderPage =
            (needsMembership && loading) ||
            (needsMembership && !loading && !currentUser)

        setShowAccountError(accountError)
        // Don't also flag the loader when there's an account error — the
        // AccountError message takes its place.
        setShowLoaderPage(loaderPage && !accountError)
    }, [currentUser, loading, needsMembership, authError])


    return { showLoaderPage, showAccountError }
}

export default useNeedsMembership
